export default [
  {
    path: "/pnr-status",
    name: "PNR-Status",
    component: () => import("@/views/reports/transaction-status/by-pnr.vue"),
    meta: {
      resource: "TransactionStatus",
      action: "View",
    },
  },
  {
    path: "/transactionID-status",
    name: "TransactionID-Status",
    component: () =>
      import("@/views/reports/transaction-status/by-transactionID.vue"),
    meta: {
      resource: "TransactionStatus",
      action: "View",
    },
  },
];
